import { render, staticRenderFns } from "./AdminPasswordEdit.vue?vue&type=template&id=42ae9ffc&"
import script from "./AdminPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports